import { CommonCallout } from 'components/common/callouts';

export const InactiveCallout = () => {
  return <CommonCallout text="settings.inactive-warning-msg" />;
};
